export const DATA_TYPE = {
  FILLED_DIAGNOSIS: 1,
  NOTIFICATION: 2,
  CLEAR_BT_DATA: 37,
  HISTORICAL_DATA: 43,
  NATIVE_SERVICES_STATUS: 51,
  NATIVE_SERVICES_STATE: 52,
  EXPOSURE_STATISTICS: 61
};
